import vuexStore from "@/store/customSaveStore";

import { storageRecommendation } from "../../recommendation/storage/store";

export const datasourcePhysicalStorage = vuexStore({
  namespaced: true,
  path: "/datasource-physical-storage",
  state: {
    editedDatasource: null,
    editedPhysicalStorage: null,
    ...storageRecommendation.state,
  },
  getters: {
    editedDatasource: (state) => state.editedDatasource,
    editedPhysicalStorage: (state) => state.editedPhysicalStorage,
    ...storageRecommendation.getters,
  },
  mutations: {
    editedDatasource: (state, value) => (state.editedDatasource = value),
    editedPhysicalStorage: (state, value) => (state.editedPhysicalStorage = value),
    ...storageRecommendation.mutations,
  },
  actions: {
    ...storageRecommendation.actions,
  },
});

export const organizationPhysicalStorage = vuexStore({
  namespaced: true,
  path: "/physical-storage",
});
